import { clearNotifications } from "utilities/js/callouts/CalloutFactory";
import { useQueryClient } from "@tanstack/react-query";
import SimplePrompt from "./SimplePrompt";
import { useState } from "react";

const NotificationPrompt = (props) => {

    const queryClient = useQueryClient();

    const [clearNotificationsDisabled, setClearNotificationsDisabled] = useState(false);

    function clearAllNotifications(){
        setClearNotificationsDisabled(true);
        clearNotifications({}).then(response => {
            queryClient.invalidateQueries({ queryKey: ['notifications'] })
            // unreadNotificationsResponse.refetch();
        
        }).catch(error => {
            console.log('Something went wrong clearing notifications as read');
            console.log(error);
        }).finally(() => {
            setTimeout(() =>{
                setClearNotificationsDisabled(false);
            }, 500);
        })
    }
        
    if(props.notifications && props.notifications.length > 0){
        return (<SimplePrompt message="Read notifications are cleared after 30 days" actions={
            <button className="nav-button h-button" onClick={clearAllNotifications} disabled={clearNotificationsDisabled}>Clear All</button>
        } variant="flush"></SimplePrompt>)
    }else{
        return (<></>)
    }

}

export default NotificationPrompt;